import React from "react";
import Skeleton from "react-loading-skeleton";

import { Badge2 } from "@/ui2/atoms/Badge";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import DraftNoteIcon from "@/assets/images/icons/draft-note.svg?component";
import { Link2 } from "@/ui2/atoms/Link";
import { providerRoute as provider } from "@/config/roles";

import { useRejectedNotesCount } from "../api/queries/useRejectedNotesCount";

type DraftNotesCardProps = {
  numberOfDraftNotes: number;
};

export function DraftNotesCard({ numberOfDraftNotes }: DraftNotesCardProps) {
  const { data: rejectedNotesCount, isLoading } = useRejectedNotesCount();

  const subText =
    numberOfDraftNotes > 0 ? (
      <Link2 className="tw:text-left" href={provider + "/draft-notes"}>
        View All
      </Link2>
    ) : (
      <p className="tw:text-base tw:text-text-teal-secondary">Great Job!</p>
    );

  return (
    <DashboardCard2 className="tw:justify-between" rawChildren>
      <div className="tw:flex tw:items-center tw:justify-between">
        <div className="tw:flex tw:items-center tw:gap-2">
          <p className="tw:mb-0 tw:text-3xl tw:font-bold tw:xl:text-5xl">{numberOfDraftNotes}</p>

          {isLoading && <Skeleton height={25} width={76} />}

          {!!rejectedNotesCount && (
            <Badge2 appearance="outline" size="md" variant="error">
              {rejectedNotesCount} Returned
            </Badge2>
          )}
        </div>

        <DraftNoteIcon className="tw:hidden tw:size-19.25 tw:md:block" />
      </div>

      <div className="tw:flex tw:flex-col tw:items-start tw:gap-1">
        <p className="tw:mt-4 tw:mb-0 tw:text-sm tw:lg:text-xl">Number Of Draft Notes</p>
        {subText}
      </div>
    </DashboardCard2>
  );
}
